import * as types from "../types/paginationType";
import { initialPaginationState } from "../initialState";

export const paginationIndex = (state = initialPaginationState, action) => {
  switch (action.type) {
    /* ACTIVE ORDER */
    case types.GET_ACTIVE_ORDER_CARD_PAGINATION_READ:
      return state;
    case types.GET_ACTIVE_ORDER_CARD_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.active_order_card_page = action.payload
      return newState;
    case types.GET_ACTIVE_ORDER_CARD_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.active_order_card_page = 1
      return newState;
    case types.GET_ACTIVE_ORDER_GRID_PAGINATION_READ:
      return state;
    case types.GET_ACTIVE_ORDER_GRID_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.active_order_grid_page = action.payload
      return newState;
    case types.GET_ACTIVE_ORDER_GRID_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.active_order_grid_page = 1
      return newState;


    /* ALLOCATED ORDER */
    case types.GET_ALLOCATED_ORDER_CARD_PAGINATION_READ:
      return state;
    case types.GET_ALLOCATED_ORDER_CARD_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.allocated_order_card_page = action.payload
      return newState;
    case types.GET_ALLOCATED_ORDER_CARD_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.allocated_order_card_page = 1
      return newState;
    case types.GET_ALLOCATED_ORDER_GRID_PAGINATION_READ:
      return state;
    case types.GET_ALLOCATED_ORDER_GRID_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.allocated_order_grid_page = action.payload
      return newState;
    case types.GET_ALLOCATED_ORDER_GRID_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.allocated_order_grid_page = 1
      return newState;


    /* VEHICLE REPORTING */
    case types.GET_VEHICLE_REPORTING_CARD_PAGINATION_READ:
      return state;
    case types.GET_VEHICLE_REPORTING_CARD_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.vehicle_reporting_card_page = action.payload
      return newState;
    case types.GET_VEHICLE_REPORTING_CARD_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.vehicle_reporting_card_page = 1
      return newState;
    case types.GET_VEHICLE_REPORTING_GRID_PAGINATION_READ:
      return state;
    case types.GET_VEHICLE_REPORTING_GRID_PAGINATION_UPDATE:
      var newState = initialPaginationState;
      newState.vehicle_reporting_grid_page = action.payload
      return newState;
    case types.GET_VEHICLE_REPORTING_GRID_PAGINATION_RESET:
      var newState = initialPaginationState;
      newState.vehicle_reporting_grid_page = 1
      return newState;

    default:
      return state;
  }
};
